module.exports = "<div class=\"limitsHeader\"></div>\n<div class=\"timeSelector\"></div>\n<div data-type=\"horizontal\" data-role=\"controlgroup\">\n    <a id=\"timeSelectorDoneButton\" href=\"#\" data-role=\"button\" data-i18n=\"common::done.title\"></a>\n</div>";


//////////////////
// WEBPACK FOOTER
// /jenkins/workspace/CudaLaunch_release_production/~/html-loader!./dyn_apps/time_selector.html
// module id = 119
// module chunks = 0